// extracted by mini-css-extract-plugin
module.exports = {"socialBtn":"Rrss_socialBtn__OPjOU","socialImg":"Rrss_socialImg__aViuA"};